// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
// import 'vant/lib/index.less';

Vue.use(Vant);
import dd from 'gdt-jsapi';
Vue.use(dd);
Vue.config.productionTip = false
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
import {post,get} from './utils/http'
//定义全局变量
Vue.prototype.$post = post;
Vue.prototype.$get = get;

Vue.config.productionTip = false
Vue.prototype.defaultImg = 'this.src="' + require('./assets/defult.jpg') + '"', //默认图地址
Vue.prototype.imgUrl = 'https://tadmin.souyisi.com:6149/';
Vue.prototype.imgUrl2 = 'https://lg.sjw.qz.gov.cn:6081/';

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js